// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"S_TheComp__Y4Vyg"};